module.exports = __webpack_public_path__ + "static/img/19.abde6ad1.jpeg";